import React, { Component } from 'react';
import SceButton from '../../../../../../../Common/CommonComponents/sceButton';
import ServiceAccountDetailsComponent from '../serviceAccountDetailsComponent';
// import overlayClasses from '../../../../Common/AddressBookDrop2/overlayStyle.scss';
import overlayClasses from './cppOverlayStyles.scss';
//import overlayClasses from '../../../../../../../Common/AddressBookDrop2/overlayStyle.scss';
import CheckBox from '../../../../../../../Common/CommonComponents/SceCheckBox';
import classes from './removePreference.scss';
import SetNotificationBulkCPP from './setNotificationBulkCPP';
import CppErrCard from './cppErrCard/cppErrCard';
import SceTextBox from '../../../../../../../Common/TextBox/sceText';
import FocusTrap from "focus-trap-react";
import { getLocalizedStrings } from '../../../notificationLocalizedStrings';

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addEmail: false,selectAllCheck: false, selectAllFlow:false,unSelectedAccounts: new Map(),
            contactData: {},
            serviceData: this.props.serviceAccountData,
            selectedContactsDetails: this.props.selectedDetails,
            selectedContactIndex: this.props.selectedContactIndex, showBulkView: false, showDeEnrollError:false,
            //viewState: this.props.viewState,    
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.strings = getLocalizedStrings('dialogBox');
        this.handleClickOutside = this.handleClickOutside.bind(this); 
        this.selectedServiceAccountArray = [];
        let emailIcon;
        let phoneIcon;
        let textIcon;
        let addIcon;
        let closeIcon;
        this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
        this.phoneIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
        this.textIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action _ Add.svg';
        this.closeIcon=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    }
    componentWillMount() {
      this.formatAccountData(true);
     
    }
    componentDidMount() {

      document.addEventListener('mousedown', this.handleClickOutside);
    } 
    componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  
    setWrapperRef(node) {
      this.wrapperRef = node;
     }
  
    handleClickOutside(event) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.closePopUp();
  
      }
    }    
    formatAccountData(thisProps, nextProps) {
      this.selectedServiceAccountArray = this.state.serviceData.saAccList;
    }
    componentWillReceiveProps(nextProps){
      this.setState({showDeEnrollError:nextProps.cppDeEnrollError});
    }
    addEmailHandler() {
        this.setState({ addEmail: true });
    }

    navigateToServiceAccount = (e) => {
      this.setState({showBulkView: !this.state.showBulkView});
    }

    onResidentialRemoveConfirmation() {
      window.aUtils.sendAAEvent("button","criticalPeakPricingTurnOff");
      if(this.state.serviceData.saAccList.length>1){
          let currProps = this.props;
          currProps.multiSelect = true;
          this.formatAccountData(null, {...currProps});}
      this.selectedServiceAccountList();
        //let viewStateUpdated = this.state.viewState;
        //viewStateUpdated.showRemoveContact = false;
        this.props.onResidentialRemoveConfirmation(this.state.contactData, null, true);
      }

      getServcieAccountsList = (saList,selectAllFlow,unselectedAccounts,contractNumbercount) => {
        let updatedState = {... this.state};
        updatedState.selectAllFlow=selectAllFlow;
        updatedState.unselectedAccounts=unselectedAccounts;
        updatedState.serviceData.saAccList = [];
        updatedState.unselectedAccountArray=[];
        updatedState.contractNumbercount=contractNumbercount;
        //converting into an array 
        if(selectAllFlow){
         updatedState.unselectedAccountArray =Array.from(unselectedAccounts.values());
        }
        _.each(saList, function(sa){
          updatedState.serviceData.saAccList.push(sa);
        });
        updatedState.showBulkView= !updatedState.showBulkView;
        updatedState.showDeEnrollError =false;
      
        this.selectedServiceAccountArray = updatedState.serviceData.saAccList;
        // this.setState({updatedState},()=>{});
        this.setState(updatedState, function(){
          let currProps = this.props;
          currProps.multiSelect = true;
          this.formatAccountData(null, {...currProps});
        });
      }

      closeUnEnrollPopUp (){
        this.props.closePopUp();
        this.setState({showDeEnrollError:false});
      }
  //Gets the selected accounts and contacts details 
  selectedServiceAccountList() {
    let selectedServiceAccounts, serviceAccountArray = [];
    let updatedStateData = { ...this.state }, serviceAccountDetails = [], selectedContactDetails = [];
    if (this.props.isResidential) {
      if (!this.props.multiSelect) {
        this.selectedAccount = this.state.serviceData.saAccList[0];
        serviceAccountArray.push(this.selectedAccount);
        updatedStateData.contactData.multipleSelectedAccounts = serviceAccountArray;
      }
      else {
        if(this.state.contractNumbercount>10 && updatedStateData.selectAllFlow){
          updatedStateData.contactData.unSelectedAccounts = updatedStateData.unselectedAccountArray;
          updatedStateData.contactData.selectAllFlag =updatedStateData.selectAllFlow;
        }
        else
        {selectedServiceAccounts = updatedStateData.serviceData.saAccList.filter(eachServiceAccount => {
          return eachServiceAccount.isSelected === true;
        });
        updatedStateData.contactData.multipleSelectedAccounts = selectedServiceAccounts;}
      }
    }
    else {
      selectedServiceAccounts = updatedStateData.serviceData.saAccList.filter(eachServiceAccount => {
        return eachServiceAccount.isSelected === true;
      });
    //   updatedStateData.contactData.selectedContactsDetails = this.state.selectedContactsDetails;
      updatedStateData.contactData.multipleSelectedAccounts = selectedServiceAccounts;
    }
    
    this.setState(updatedStateData);
  }
  getViewToShow = () => {
    if(!this.state.showBulkView ) {
        // const buttonJSX = <div className={'col-xs-12 col-sm-6 col-sm-push-6 text-align-right ' + overlayClasses.sceFooterBtns}><span className=''><SceButton value='Yes, Remove' buttonType='sceSmPrimary' />  </span></div>;
        let serviceAccountDetailsJSX;
        serviceAccountDetailsJSX = <ServiceAccountDetailsComponent contractNumbercount={this.state.contractNumbercount}
        unselectedAccountArray={this.state.unselectedAccountArray} selectAllCheck={this.state.selectAllCheck} selectAllFlow={this.state.selectAllFlow}unSelectedAccounts={this.state.unSelectedAccounts}selectedAccount={this.selectedServiceAccountArray} />;
        let cppDeEnrollErrorJSX = this.state.showDeEnrollError?<div><CppErrCard onFormhandler={this.onResidentialRemoveConfirmation.bind(this)} /></div>:null;
        return (
            <div>
                  <div className='row'>
                        <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{"Turn Off Critical Peak Pricing Notifications"}<button className={classes.iconClose} onClick={() => this.closeUnEnrollPopUp()} ><img src={this.closeIcon} alt="Close Icon" />
                          </button></div>
                        {cppDeEnrollErrorJSX}
                        <div className={'col-xs-12 ' + classes.sceSetNotificationHeader}>{"Are you sure you want to turn off Critical Peak Pricing (CPP) Notifications for this address?"}</div>
                        {this.props.contractNumbercount > 1 ?<div className={'col-xs-12 ' + classes.multiViewPadding}><div className={'col-xs-12'+classes.multiAccountLinkPadding}>{this.state.serviceData.saAccList.length > 1 || this.state.selectAllFlow?<a className={classes.sceSmLink +" pull-right"} onClick={(e)=>this.navigateToServiceAccount(e)} href="javascript::void(0)">{'Edit Service Accounts >'}</a>:<a className={classes.sceSmLink +" pull-right"} onClick={(e)=>this.navigateToServiceAccount(e)} href="javascript::void(0)">{'Add More Service Accounts >'}</a>}</div></div> : null}
                    </div>
                    {/* {this.props.isResidential ? <div className={classes.sceRemoveContactListRes}>{ContactDetailsJSx}</div> : <div className={classes.sceRemoveContactList}>{ContactDetailsJSx}</div>}
                    {this.props.isResidential ? <div className={classes.sceRemoveContactText}>{this.strings.removeText}</div> : null}
                    {!this.props.isResidential ? <div className={classes.sceRemoveContactText}>{this.props.multiSelect ? this.strings.removeMessage : this.strings.removeMessageSingle}</div> : null} */}
                    <div className={classes.servAccDetails}>{serviceAccountDetailsJSX}</div>
                    {/* <p className={classes.sceRemoveConfirm}>{this.props.multiSelect ? this.strings.removeConfirmationTextCom : this.strings.removeConfirmationText}</p> */}

                    <div className={'row ' + classes.sceFooterBtnStyles}>
                    <div className="text-align-center">
                     {this.props.contractNumbercount > 1 ?<span>{this.strings.bulkNote}</span>:null} </div>
                    <div className={'col-xs-12 col-sm-6 col-sm-push-2 ' + classes.sceFooterBtns + ' ' + classes.paddingCenter}>
                        <div className={classes.turnOnBtn}>
                            <SceButton
                                id="criticalPeakPricingTurnOff"
                                iconType='rightArrow'
                                buttonType='primary'
                                value='Yes, Turn Off Notifications'
                                onClick={() => this.onResidentialRemoveConfirmation()}
                            />
                        </div><br />
                        <div className={classes.cancelBtn}>
                            <SceButton
                                id='criticalPeakPricingCancel'
                                iconType='cancel'
                                buttonType='default'
                                value='Cancel'
                                onClick={() => this.closeUnEnrollPopUp()}
                            />
                        </div>
                    </div>
                </div>    
            </div>
        );
      }else{
        return (<SetNotificationBulkCPP 
          selectAllCheck={this.state.selectAllCheck} selectAllFlow={this.state.selectAllFlow}unSelectedAccounts={this.state.unSelectedAccounts}
          navigateBackFromServiceAccount={this.navigateToServiceAccount} contractAccountNumber={this.props.contractAccountNumber} headerText={'Turn Off Critical Peak Pricing Notifications'} selectedServiceAccounts={this.state.serviceData.saAccList} getServcieAccountsList={this.getServcieAccountsList} currentSelectedServiceAccount={this.state.serviceData.saAccList[0].contractNumber} closePopUp={this.props.closePopUp} />);
      }
  }
    render() {
      let view = this.getViewToShow();
      return (
        <FocusTrap 
        focusTrapOptions={{
           allowOutsideClick: true,
       }}
       >
          <div className={classes.Main}>
              <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceRemoveContactDialog].join(' ')}>
                  <div className={overlayClasses.sceOverlayContent}>
                      <div ref={this.setWrapperRef} className={[overlayClasses.sceDialogBox,classes.dilogBox].join(' ')}>
                          {view}
                      </div>
                  </div>
              </div>;
          </div>
        </FocusTrap>
      );
      }
}
